import { render } from "./ChatIndex.vue?vue&type=template&id=2370ce10&scoped=true"
import script from "./ChatIndex.vue?vue&type=script&lang=js"
export * from "./ChatIndex.vue?vue&type=script&lang=js"

import "./ChatIndex.vue?vue&type=style&index=0&id=2370ce10&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2370ce10"]])

export default __exports__